import React from 'react';
import Rating from 'components/Rating';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Colors from 'utils/colors';
import ClassNames from 'classnames';
import Numeral from 'numeral';

const styles = () => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  text: {
    fontSize: 10,
    marginLeft: 5,
  },

  total: {
    color: Colors.gray,
  },
  icon: {
    fontSize: 15,
  },
  iconWrapper: {
    display: 'flex !important',
  },
  padded: {
    paddingLeft: 10,
  },
  whiteText: {
    color: '#fff',
  },
});
function ResourceRating({ classes, value = 0, total = 0, resource }) {
  const isVideo = resource === 'VIDEO';
  return (
    <div className={ClassNames(classes.root, isVideo ? classes.padded : null)}>
      <Rating name={`${resource}-rating`} value={value} />
      <Typography
        variant="subtitle2"
        className={ClassNames(classes.text, isVideo ? classes.whiteText : null)}
      >
        {value}
      </Typography>
      <Typography
        variant="subtitle2"
        className={ClassNames(classes.text, classes.total)}
      >
        {`(${Numeral(total).format('0a')})`}
      </Typography>
    </div>
  );
}

ResourceRating.propTypes = {
  value: PropTypes.number,
  classes: PropTypes.object,
  total: PropTypes.number,
  resource: PropTypes.string,
};

export default withStyles(styles)(ResourceRating);
